import React, { useState } from 'react';
import '../styles/pages/CustomerReview.css';

const CustomerReview = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const reviews = [
    {
      id: 1,
      name: "Rajesh Sharma",
      company: "Sharma Events & Decor",
      rating: 5,
      date: "January 2024",
      service: "Wedding Cards",
      comment: "Outstanding quality of wedding cards! The design team at Gyaniraj Offset created exactly what we envisioned. The multicolor printing and die-cutting work was flawless. Highly recommended for any wedding printing needs.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100"
    },
    {
      id: 2,
      name: "Priya Patel",
      company: "Patel Retail Chain",
      rating: 5,
      date: "December 2023",
      service: "Flex Printing",
      comment: "Excellent service for our retail chain's flex printing needs. The quality of star flex and backlight printing is exceptional. Timely delivery and professional approach. Our store branding looks amazing!",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100"
    },
    {
      id: 3,
      name: "Vikram Singh",
      company: "Singh Constructions",
      rating: 4,
      date: "December 2023",
      service: "LED Signage",
      comment: "Very impressed with the LED signage work done for our construction sites. The acrylic LED letters are bright and durable. The CNC cutting work on wooden signs is precise and professional.",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100"
    },
    {
      id: 4,
      name: "Anita Desai",
      company: "Desai Boutique",
      rating: 5,
      date: "November 2023",
      service: "Business Cards",
      comment: "The 800 GSM visiting cards with velvet finish are absolutely stunning! The foil stamping and UV coating options provided by Gyaniraj Offset make my business stand out. Exceptional quality!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100"
    },
    {
      id: 5,
      name: "Mohammed Khan",
      company: "Khan Advertising Agency",
      rating: 5,
      date: "November 2023",
      service: "Brochure Printing",
      comment: "Professional brochure printing with excellent color accuracy. The offset printing quality is superb, and the paper selection guidance was very helpful. Great value for money!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100"
    },
    {
      id: 6,
      name: "Sunita Verma",
      company: "Verma Wedding Planners",
      rating: 5,
      date: "October 2023",
      service: "Complete Wedding Package",
      comment: "Used Gyaniraj Offset for complete wedding printing - from cards to banners to signage. Everything was perfect! The team is very cooperative and understands client requirements perfectly.",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100"
    }
  ];

  const stats = {
    totalReviews: reviews.length,
    averageRating: (reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length).toFixed(1),
    satisfactionRate: "98%"
  };

  const services = ['all', 'Wedding Cards', 'Flex Printing', 'LED Signage', 'Business Cards', 'Brochure Printing'];

  const filteredReviews = activeFilter === 'all' 
    ? reviews 
    : reviews.filter(review => review.service === activeFilter);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  return (
    <div className="review-page">
      <div className="review-hero">
        <div className="container">
          <h1>Customer Reviews</h1>
          <p>See what our satisfied customers say about our printing services</p>
        </div>
      </div>

      <div className="review-content">
        <div className="container">
          <section className="review-stats">
            <div className="stats-grid">
              <div className="stat-card">
                <h3>{stats.totalReviews}+</h3>
                <p>Happy Customers</p>
              </div>
              <div className="stat-card">
                <h3>{stats.averageRating}/5</h3>
                <p>Average Rating</p>
              </div>
              <div className="stat-card">
                <h3>{stats.satisfactionRate}</h3>
                <p>Satisfaction Rate</p>
              </div>
            </div>
          </section>

          <section className="review-filters">
            <h3>Filter by Service</h3>
            <div className="filter-buttons">
              {services.map((service) => (
                <button
                  key={service}
                  className={`filter-btn ${activeFilter === service ? 'active' : ''}`}
                  onClick={() => setActiveFilter(service)}
                >
                  {service === 'all' ? 'All Services' : service}
                </button>
              ))}
            </div>
          </section>

          <section className="reviews-grid">
            {filteredReviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-header">
                  <img src={review.image} alt={review.name} className="reviewer-image" />
                  <div className="reviewer-info">
                    <h4>{review.name}</h4>
                    <p className="company">{review.company}</p>
                    <div className="rating">{renderStars(review.rating)}</div>
                  </div>
                  <span className="review-date">{review.date}</span>
                </div>
                
                <div className="service-tag">{review.service}</div>
                
                <p className="review-text">{review.comment}</p>
                
                <div className="review-actions">
                  <button className="helpful-btn">👍 Helpful</button>
                  <button className="share-btn">Share Review</button>
                </div>
              </div>
            ))}
          </section>

          <section className="add-review">
            <div className="add-review-card">
              <h3>Share Your Experience</h3>
              <p>Help others make informed decisions by sharing your feedback</p>
              <button className="write-review-btn">Write a Review</button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CustomerReview;
